import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../../../utils/validators/string';
import { TicketRedemptionCodeCategory } from './ticket-redemption-code-category';
import { ticketRedemptionCodeFormatValidator } from './ticket-redemption-code-format';
/**
 * Indicates whether a PIN is required.
 */
export var TicketVoucherTypePin;
(function (TicketVoucherTypePin) {
    /**
     * Not required for any voucher types.
     */
    TicketVoucherTypePin["None"] = "None";
    /**
     * Required for all voucher types.
     */
    TicketVoucherTypePin["Required"] = "Required";
    /**
     * Required for some voucher types.
     */
    TicketVoucherTypePin["Optional"] = "Optional";
})(TicketVoucherTypePin || (TicketVoucherTypePin = {}));
export const defaultTicketVoucherType = {
    id: 'voucher',
    category: TicketRedemptionCodeCategory.Voucher,
    label: 'Voucher',
    pin: TicketVoucherTypePin.Required,
    codeFormat: undefined
};
export const defaultTicketRedemptionCodeTypes = [defaultTicketVoucherType];
const ticketVoucherTypeValidator = Validator.object({
    id: nonEmptyStringValidator,
    category: Validator.isEqualTo(TicketRedemptionCodeCategory.Voucher),
    label: nonEmptyStringValidator,
    iconName: Validator.optional(nonEmptyStringValidator),
    pin: Validator.oneOf(Object.values(TicketVoucherTypePin)),
    codeFormat: Validator.optional(ticketRedemptionCodeFormatValidator)
});
const thirdPartyMemberCardTypeValidator = Validator.object({
    id: nonEmptyStringValidator,
    category: Validator.isEqualTo(TicketRedemptionCodeCategory.ThirdPartyMemberCard),
    thirdPartyMemberSchemeId: nonEmptyStringValidator,
    label: nonEmptyStringValidator,
    iconName: Validator.optional(nonEmptyStringValidator),
    codeFormat: Validator.optional(ticketRedemptionCodeFormatValidator)
});
const memberSubscriptionCardTypeValidator = Validator.object({
    id: nonEmptyStringValidator,
    category: Validator.isEqualTo(TicketRedemptionCodeCategory.MemberSubscriptionCard),
    subscriptionId: Validator.number({ min: 0 }),
    label: nonEmptyStringValidator,
    iconName: Validator.optional(nonEmptyStringValidator),
    codeFormat: Validator.optional(ticketRedemptionCodeFormatValidator)
});
export const ticketRedemptionCodeTypeValidator = Validator.any([
    ticketVoucherTypeValidator,
    thirdPartyMemberCardTypeValidator,
    memberSubscriptionCardTypeValidator
]);
